// @flow
import React, { Component } from 'react';
import { Schedule } from '~/components/widgets';
import { Base } from './styles';

type Props = {
    scheduleComponentId: string,
    setNewSchedule: () => {}
};
export default class ActionSchedule extends Component<Props> {
    componentWillMount() {
        const { setNewSchedule } = this.props;
        setNewSchedule();
    }

    render() {
        const { scheduleComponentId } = this.props;
        return (
            <Base>
                <Schedule componentId={scheduleComponentId} />
            </Base>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/attribute-types/schedule/component.js